import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import Dashboard from "../../components/lotto12v2/Dashboard";
import Lotto12v2Nav from "../../components/lotto12v2/Lotto12v2Nav";
import {lotto12DrawStyle} from "../../constants/general";
import MainDrawingWrapper from "../../components/lotto12v2/MainDrawingWrapper";

class Index extends Component {
    render() {
        return (
            <MainDrawingWrapper drawStyle={lotto12DrawStyle.circle}>
                <Lotto12v2Nav/>
                <Dashboard />
            </MainDrawingWrapper>
        );
    }
}


export default withTranslation()(Index)
